import { isAuthoredEmoji } from '@/lib/icons'

/**
 * The text stand-in for an authored icon in a slot that can only hold text —
 * a native `<option>`, where an `<img>` cannot go and `AuthoredIcon`
 * therefore cannot be used.
 *
 * An authored emoji is shown as itself; a filename or URL falls back to a
 * generic book, because the real picture has nowhere to render. Includes the
 * trailing space so callers can concatenate it straight onto a label.
 *
 * Lives here rather than in `lib/icons.ts` because it is a *rendering*
 * decision — it picks a substitute glyph and bakes in a trailing space —
 * whereas that module's job is path construction and format classification.
 * It sits beside `kind-icons.ts`, the other rendering-policy module, so the
 * two are placed by the same rule. It still imports the classification from
 * `lib/icons`: deciding whether a value *is* an emoji stays over there.
 *
 * @example
 * authoredIconTextPrefix('📗')          // => "📗 "
 * authoredIconTextPrefix('leetcode.png') // => "📖 "
 * authoredIconTextPrefix(null)           // => ""
 */
export function authoredIconTextPrefix(
  iconValue: string | null | undefined,
): string {
  const value = iconValue?.trim() ?? ''
  if (value === '') return ''
  return isAuthoredEmoji(value) ? `${value} ` : '📖 '
}
